import $i18n from 'panda-i18n';
import locale from './index';
export default $i18n.init({
    locale: locale,
    packageName: 'cn-ui-common',
});
